import React from "react";
import moment from "moment";
import { ErrorLoader } from "../../../../UI/Loaders/Loaders";

interface ViewBlackListModalProps {
  dataRecord: any;
  onCloseModal: () => void;
}

const ViewBlackListModal: React.FC<ViewBlackListModalProps> = ({
  dataRecord,
  onCloseModal,
}) => {
  const {
    firstName,
    lastName,
    businessName,
    customerType,
    email,
    phoneNumber,
    bvn,
    nin,
    rcNumber,
    activationReason,
    deactivationReason,
    createdByName,
    createdAt,
    deactivatedByName,
    deactivatedAt,
    isActive,
  } = dataRecord || {};

  // Determine customer name based on type
  const customerName =
    customerType === "Organisation"
      ? businessName
      : `${firstName || ""} ${lastName || ""}`.trim();

  const handleRemoveFromBlacklist = () => {
    // TODO: Implement API call to remove from blacklist
    console.log("Removing from blacklist:", dataRecord);
    onCloseModal();
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <React.Fragment>
            <h3 className="Modal__title p-b-1">BlackList Entry Details</h3>

            {/* BlackList Details View */}
            <div id="blacklist-details">
              <div className="m-b-30">
                <div className="card mb-3">
                  <div className="card-header font-weight-bold">
                    Customer Information
                  </div>
                  <div className="card-body">
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <strong>Customer Name:</strong>
                      </div>
                      <div className="col-md-8">{customerName || "N/A"}</div>
                    </div>
                    <hr />
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <strong>Customer Type:</strong>
                      </div>
                      <div className="col-md-8">
                        <span className="badge badge-info">
                          {customerType || "N/A"}
                        </span>
                      </div>
                    </div>
                    <hr />
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <strong>Email:</strong>
                      </div>
                      <div className="col-md-8">{email || "N/A"}</div>
                    </div>
                    <hr />
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <strong>Phone Number:</strong>
                      </div>
                      <div className="col-md-8">{phoneNumber || "N/A"}</div>
                    </div>
                    {customerType === "Organisation" && rcNumber && (
                      <>
                        <hr />
                        <div className="row mb-2">
                          <div className="col-md-4">
                            <strong>RC Number:</strong>
                          </div>
                          <div className="col-md-8">{rcNumber}</div>
                        </div>
                      </>
                    )}
                    {customerType === "Individual" && (
                      <>
                        {bvn && (
                          <>
                            <hr />
                            <div className="row mb-2">
                              <div className="col-md-4">
                                <strong>BVN:</strong>
                              </div>
                              <div className="col-md-8">{bvn}</div>
                            </div>
                          </>
                        )}
                        {nin && (
                          <>
                            <hr />
                            <div className="row mb-2">
                              <div className="col-md-4">
                                <strong>NIN:</strong>
                              </div>
                              <div className="col-md-8">{nin}</div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>

                <div className="card mb-3">
                  <div className="card-header font-weight-bold">
                    BlackList Details
                  </div>
                  <div className="card-body">
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <strong>Activation Reason:</strong>
                      </div>
                      <div className="col-md-8">
                        {activationReason || "N/A"}
                      </div>
                    </div>
                    {deactivationReason && (
                      <>
                        <hr />
                        <div className="row mb-2">
                          <div className="col-md-4">
                            <strong>Deactivation Reason:</strong>
                          </div>
                          <div className="col-md-8">{deactivationReason}</div>
                        </div>
                      </>
                    )}
                    <hr />
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <strong>Blacklisted By:</strong>
                      </div>
                      <div className="col-md-8">{createdByName || "N/A"}</div>
                    </div>
                    <hr />
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <strong>Date Blacklisted:</strong>
                      </div>
                      <div className="col-md-8">
                        {createdAt
                          ? moment(createdAt).format("MMMM Do YYYY, h:mm:ss a")
                          : "N/A"}
                      </div>
                    </div>
                    {deactivatedAt && (
                      <>
                        <hr />
                        <div className="row mb-2">
                          <div className="col-md-4">
                            <strong>Deactivated At:</strong>
                          </div>
                          <div className="col-md-8">
                            {moment(deactivatedAt).format(
                              "MMMM Do YYYY, h:mm:ss a"
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {deactivatedByName && (
                      <>
                        <hr />
                        <div className="row mb-2">
                          <div className="col-md-4">
                            <strong>Deactivated By:</strong>
                          </div>
                          <div className="col-md-8">{deactivatedByName}</div>
                        </div>
                      </>
                    )}
                    <hr />
                    <div className="row mb-2">
                      <div className="col-md-4">
                        <strong>Status:</strong>
                      </div>
                      <div className="col-md-8">
                        <span
                          className={`badge ${
                            isActive ? "badge-success" : "badge-danger"
                          }`}
                        >
                          {isActive ? "Active" : "Inactive"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="Form__action-buttons m-t-2">
                  {/* {isActive && (
                    <button
                      type="button"
                      onClick={handleRemoveFromBlacklist}
                      className="btn zoom-element btn login-btn m-0 mr-auto"
                      style={{ backgroundColor: "#dc3545" }}
                    >
                      <i className="fa fa-ban" /> Deactivate BlackList
                    </button>
                  )} */}
                  <button
                    type="button"
                    onClick={onCloseModal}
                    className="btn zoom-element btn login-btn m-0 ml-auto"
                  >
                    <i className="fa fa-times-circle" /> Close
                  </button>
                </div>
              </div>
            </div>

            {/* Loader */}
            <div
              id="blacklist-remove-loader"
              className="hidden loading-overlay speed-1x fadeInRight"
            >
              <div className="form-loader form-loader-login verify">
                <div className="centerLoader">
                  <div className="loading" id="adv-loader-alt" />
                  <div className="center-txt webapp-ripple-text">
                    <i className="notifier fas fa-ban" />
                    Removing from BlackList...
                  </div>
                </div>
              </div>
            </div>

            {/* Success Message */}
            <div
              id="blacklist-remove-success"
              className="hidden loading-overlay speed-1x fadeInRight"
            >
              <div className="form-loader form-loader-login verify">
                <div className="centerLoader">
                  <div className="loading success-loader">
                    <i className="webapp-ripple-notification success-text fa fa-check-circle" />
                  </div>
                  <div className="center-txt webapp-ripple-text">
                    <i className="notifier far fa-check-circle" />
                    Successfully Removed from BlackList
                  </div>
                </div>
              </div>
            </div>

            {/* Error */}
            <div
              id="blacklist-remove-error"
              className="hidden loading-overlay speed-1x fadeInRight"
            >
              <ErrorLoader
                icon="fas fa-wifi"
                text="Network Issue"
                subText="Unable to connect to Advancly services."
              />
            </div>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

export default ViewBlackListModal;
